import { render } from "./FlipCard.vue?vue&type=template&id=c3487dc6"
import script from "./FlipCard.vue?vue&type=script&lang=js"
export * from "./FlipCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__